/* Categories panel: open/close (same slide-in pattern as cart/profile/
   wishlist) plus two independent levels of tab-switching — the top tabs
   (one per top-level item of the header's navigation menu, so the same
   worlds as the desktop mega menu), and each tab's own sidebar selection
   (Curation/Brands/categories). Both use the same
   toggle-a-class-by-data-attribute approach already used for the CLP
   curation rail's tabs. */
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.getElementById('categoriesPanel');
  var backdrop = document.getElementById('categoriesPanelBackdrop');
  if (!panel || !backdrop) return;

  function openPanel() {
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      backdrop.classList.add('is-visible');
      panel.classList.add('is-open');
    });
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    backdrop.classList.remove('is-visible');
    panel.classList.remove('is-open');
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { backdrop.hidden = true; showView('categories'); }, 320);
  }

  /* Categories | Brands. The Brands text tab beside the title slides the
     brands view in over the categories; the title slides them back. The
     hidden view is inert so it cannot be tabbed into. */
  function showView(name) {
    var brands = name === 'brands';
    panel.classList.toggle('is-brands', brands);
    panel.querySelectorAll('[data-cat-view]').forEach(function (t) {
      var on = t.getAttribute('data-cat-view') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    panel.querySelectorAll('[data-cat-view-panel]').forEach(function (v) {
      var on = v.getAttribute('data-cat-view-panel') === name;
      if (on) { v.removeAttribute('inert'); v.setAttribute('aria-hidden', 'false'); }
      else { v.setAttribute('inert', ''); v.setAttribute('aria-hidden', 'true'); }
    });
    if (brands) {
      var scroller = panel.querySelector('[data-brand-scroll]');
      if (scroller) scroller.scrollTop = 0;
    }
  }
  panel.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cat-view]');
    if (t) showView(t.getAttribute('data-cat-view'));
  });

  window.VroCategoriesPanel = { open: openPanel, close: closePanel };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-categories-panel-open]')) {
      e.preventDefault();
      openPanel();
      return;
    }
    if (e.target.closest('[data-categories-panel-close]') || e.target === backdrop) {
      closePanel();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });

  /* The tab row scrolls sideways once the menu has more worlds than fit,
     so bring a tapped tab fully into view. Scrolls only the row itself —
     scrollIntoView would also nudge the fixed panel. */
  function revealTab(tabs, tab) {
    var left = tab.offsetLeft - tabs.offsetLeft;
    var right = left + tab.offsetWidth;
    var pad = 24;
    if (left - pad < tabs.scrollLeft) {
      tabs.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
    } else if (right + pad > tabs.scrollLeft + tabs.clientWidth) {
      tabs.scrollTo({ left: right + pad - tabs.clientWidth, behavior: 'smooth' });
    }
  }

  /* Top tabs: one per menu world */
  panel.querySelectorAll('.cat-panel-tabs').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-cat-tab]');
      if (!tab) return;
      var id = tab.getAttribute('data-cat-tab');

      tabs.querySelectorAll('[data-cat-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      panel.querySelectorAll('[data-cat-tab-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cat-tab-panel') === id);
      });
      revealTab(tabs, tab);
    });
  });

  /* Sidebar within each tab. data-cat-sidebar-group scopes the toggle to
     just that tab's own sidebar+content, so switching one tab's selection
     doesn't affect another tab's. */
  panel.querySelectorAll('[data-cat-sidebar-group]').forEach(function (item) {
    item.addEventListener('click', function () {
      var group = item.getAttribute('data-cat-sidebar-group');
      var id = item.getAttribute('data-cat-sidebar');
      var tabPanel = item.closest('[data-cat-tab-panel]');
      if (!tabPanel) return;

      tabPanel.querySelectorAll('[data-cat-sidebar-group="' + group + '"]').forEach(function (el) {
        el.classList.toggle('is-active', el === item);
      });
      tabPanel.querySelectorAll('[data-cat-sidebar-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cat-sidebar-panel') === id);
      });

      /* A long category list leaves the content scrolled down; each new
         category should open at its heading. */
      var content = tabPanel.querySelector('.cat-content');
      if (content) content.scrollTop = 0;
    });
  });

  /* ---------------------------------------------------------------
     Brands: live search, and the A-Z list with its letter strip

     Every brand tile or row carries data-brand-name. The search box above
     them hides whatever does not match as you type (no submit, no page
     load) in the logo grid and in the names list alike. With the names
     layout (Brands shown as = Names) the rows are also sorted here, split
     under letter headings, and the strip at the right jumps to a letter,
     by tap or by dragging a finger down it.
  --------------------------------------------------------------- */
  function brandKey(name) {
    var c = (name || '').trim().charAt(0).toUpperCase();
    return (c >= 'A' && c <= 'Z') ? c : '#';
  }

  panel.querySelectorAll('.cat-content-panel, [data-brand-scroll]').forEach(function (brandPanel) {
    var form = brandPanel.querySelector('[data-brand-search]');
    if (!form) return;
    var input = form.querySelector('input');
    var empty = brandPanel.querySelector('[data-brand-empty]');
    var wrap = brandPanel.querySelector('[data-brand-names]');
    var list = wrap && wrap.querySelector('[data-brand-list]');
    var rail = wrap && wrap.querySelector('[data-az-rail]');
    /* The scroller: the tab panel's .cat-content, or the Brands view itself. */
    var content = brandPanel.closest('.cat-content') || brandPanel;

    if (list && rail) buildNames();

    function buildNames() {
      var rows = Array.prototype.slice.call(list.querySelectorAll('.cat-brand-name-row'));
      rows.sort(function (a, b) {
        var ka = brandKey(a.getAttribute('data-brand-name'));
        var kb = brandKey(b.getAttribute('data-brand-name'));
        if (ka !== kb) return ka === '#' ? -1 : kb === '#' ? 1 : (ka < kb ? -1 : 1);
        return a.getAttribute('data-brand-name').localeCompare(b.getAttribute('data-brand-name'), undefined, { sensitivity: 'base' });
      });
      list.innerHTML = '';
      var seen = {};
      rows.forEach(function (row) {
        var key = brandKey(row.getAttribute('data-brand-name'));
        if (!seen[key]) {
          seen[key] = true;
          var h = document.createElement('p');
          h.className = 'cat-brand-letter';
          h.setAttribute('data-letter', key);
          h.textContent = key;
          list.appendChild(h);
        }
        row.setAttribute('data-letter', key);
        list.appendChild(row);
      });

      rail.innerHTML = '';
      '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (l) {
        if (l === '#' && !seen['#']) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = l;
        b.setAttribute('data-az', l);
        b.setAttribute('aria-label', l);
        rail.appendChild(b);
      });
      paintRail();
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* A tap glides to the letter; a drag along the strip jumps, because a
       glide per finger-move would trail behind it. */
    var ORDER = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    /* The heading a tapped letter leads to: its own, or, with no brand under
       that letter (or none left after a search), the next letter that has
       one, as a phone's contact list does. Past the last one, the last. */
    function headFor(letter) {
      var heads = list.querySelectorAll('.cat-brand-letter:not(.is-hidden)');
      var from = ORDER.indexOf(letter);
      var found = null;
      heads.forEach(function (h) {
        if (!found && ORDER.indexOf(h.getAttribute('data-letter')) >= from) found = h;
      });
      return found || heads[heads.length - 1] || null;
    }

    function jumpTo(letter, glide) {
      var head = headFor(letter);
      if (!head || !content) return;
      letter = head.getAttribute('data-letter');
      var top = head.getBoundingClientRect().top - content.getBoundingClientRect().top + content.scrollTop - clearance();
      content.scrollTo({ top: Math.max(0, top), behavior: glide && !reduceMotion ? 'smooth' : 'auto' });
      markLetter(letter);
      head.classList.remove('is-pulse');
      void head.offsetWidth;
      head.classList.add('is-pulse');
    }

    /* How much of the top of the list the sticky search box covers. */
    function clearance() {
      var bar = form.parentNode;
      return (bar && bar.offsetHeight ? bar.offsetHeight : 78) + 8;
    }

    /* The strip lights the letter being read, as the list scrolls. */
    function markLetter(letter) {
      if (!rail) return;
      rail.querySelectorAll('[data-az]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-az') === letter);
      });
    }

    function spy() {
      if (!list || !content || !content.offsetParent) return;
      var line = content.getBoundingClientRect().top + clearance() + 36;
      var current = null;
      var heads = list.querySelectorAll('.cat-brand-letter:not(.is-hidden)');
      heads.forEach(function (h) {
        if (h.getBoundingClientRect().top <= line) current = h.getAttribute('data-letter');
      });
      /* At the very end the last letter is the one being read, even when
         its heading never reaches the top. */
      if (content.scrollTop + content.clientHeight >= content.scrollHeight - 2 && heads.length) {
        current = heads[heads.length - 1].getAttribute('data-letter');
      }
      markLetter(current || (heads[0] ? heads[0].getAttribute('data-letter') : null));
    }
    if (list && content) {
      var spying = false;
      content.addEventListener('scroll', function () {
        if (spying) return;
        spying = true;
        requestAnimationFrame(function () { spying = false; spy(); });
      }, { passive: true });
    }

    if (rail) {
      rail.addEventListener('click', function (e) {
        var b = e.target.closest('[data-az]');
        if (b) jumpTo(b.getAttribute('data-az'), true);
      });
      /* Dragging along the strip scrubs through the letters, like a phone
         contact list. */
      var dragging = false;
      var scrub = function (e) {
        var el = document.elementFromPoint(e.clientX, e.clientY);
        var b = el && el.closest && el.closest('[data-az]');
        if (b && rail.contains(b)) jumpTo(b.getAttribute('data-az'));
      };
      rail.addEventListener('pointerdown', function (e) { dragging = true; scrub(e); });
      rail.addEventListener('pointermove', function (e) { if (dragging) scrub(e); });
      document.addEventListener('pointerup', function () { dragging = false; });
      document.addEventListener('pointercancel', function () { dragging = false; });
    }

    /* Letters with no brand showing (under the current search) dim out in
       the strip and lose their heading in the list. */
    function paintRail() {
      if (!list) return;
      var live = {};
      list.querySelectorAll('.cat-brand-name-row:not(.is-hidden)').forEach(function (r) {
        live[r.getAttribute('data-letter')] = true;
      });
      list.querySelectorAll('.cat-brand-letter').forEach(function (h) {
        h.classList.toggle('is-hidden', !live[h.getAttribute('data-letter')]);
      });
      if (rail) rail.querySelectorAll('[data-az]').forEach(function (b) {
        b.classList.toggle('is-empty', !live[b.getAttribute('data-az')]);
      });
    }

    function filter() {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      brandPanel.querySelectorAll('[data-brand-name]').forEach(function (item) {
        var hit = !q || item.getAttribute('data-brand-name').toLowerCase().indexOf(q) > -1;
        item.classList.toggle('is-hidden', !hit);
        if (hit) {
          shown++;
          /* Restart the fade so the rows that remain ease in, rather than
             the list snapping to its new shape. */
          item.classList.remove('is-entering');
          void item.offsetWidth;
          item.classList.add('is-entering');
        }
      });
      paintRail();
      if (empty) {
        empty.hidden = shown > 0;
        if (!empty.hidden) { empty.classList.remove('is-entering'); void empty.offsetWidth; empty.classList.add('is-entering'); }
      }
      if (content) content.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      spy();
    }

    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    /* Enter stays on the page: the results are already showing. */
    form.addEventListener('submit', function (e) { e.preventDefault(); input.blur(); });
  });
});
